"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const d3 = __importStar(require("d3"));
const lodash_1 = __importDefault(require("lodash"));
const canvas_1 = require("canvas");
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
const constants_1 = require("../../constants");
const chart_helpers_1 = require("../../util/chart.helpers");
const Triggerable_1 = __importDefault(require("../../util/Triggerable"));
require("./TimeBarChart.scss");
const common_module_scss_1 = __importDefault(require("../../styles/common.module.scss"));
const colours_module_scss_1 = __importDefault(require("../../styles/colours.module.scss"));
const SourcesAndFootnotes_1 = __importDefault(require("../SourcesAndFootnotes"));
const Tooltip_1 = __importDefault(require("../Tooltip"));
const InfoTooltip_1 = __importDefault(require("../InfoTooltip"));
const error_1 = require("../error");
const transitions_1 = require("../../util/transitions");
const LABEL_PADDING = 10;
const DEFAULT_HEIGHT = 500;
const AXIS_PADDING = 10;
const TRANSITION_LENGTH = 1000;
function measureYAxis(drawParams, ticks, fontSize) {
  const context = (0, canvas_1.createCanvas)(300, 300).getContext('2d');
  context.font = `${fontSize}px ${common_module_scss_1.default.mainFontFamily}`;
  const format = (0, chart_helpers_1.valueFormat)(drawParams);
  return lodash_1.default.max(ticks.map(tick => context.measureText(format(tick)).width));
}
const dateRangeFunctions = {
  months: d3.utcMonth,
  monthly: d3.utcMonth,
  quarters: d3.utcMonth.every(3),
  quarterly: d3.utcMonth.every(3),
  days: d3.utcDay,
  daily: d3.utcDay,
  weeks: d3.utcDay.every(7),
  weekly: d3.utcDay.every(7),
  years: d3.utcYear,
  yearly: d3.utcYear
};
class TimeBarChart extends Triggerable_1.default {
  constructor(container, width, height, cssPrefix) {
    super();
    this.chartType = constants_1.CHART_TYPES.TimeBarChart;
    this.cssPrefix = cssPrefix || 'time-bar-chart';
    this.container = container;
    this.drawCanvas = undefined;
    this.initialDraw = true;
    this.yTicks = 4;
    this.xTicks = 8;
    this.width = width || 1000;
    this.height = height || DEFAULT_HEIGHT;
    this.margins = {
      top: 20,
      bottom: 50,
      left: 10,
      right: 10,
      minRightLabel: 0,
      maxRightLabelRatio: undefined
    };
    this.title = container.append('div').classed('chart-title', true);
    this.subtitle = container.append('div').classed('chart-subtitle', true);
    this.svg = container.classed(this.cssPrefix, true).classed('dh-chart-wrapper', true).append('svg').classed(this.cssPrefix, true).attr('viewBox', `0 0 ${this.width} ${this.height}`);
    this.sourceContainer = this.container.append('div');
    this.sources = new SourcesAndFootnotes_1.default(this.sourceContainer);
    this.tooltip = new Tooltip_1.default(container);
    this.initGroups();
    this.ro = new resize_observer_polyfill_1.default(entries => {
      entries.forEach(entry => {
        requestAnimationFrame(() => {
          this.resizeContent(entry.contentRect);
        });
      });
    });
    this.ro.observe(container.node());
  }
  initGroups() {
    this.defs = this.svg.append('defs');
    this.svg.append('g').classed('axis', true).classed('y', true);
    this.svg.append('g').classed('axis', true).classed('x', true);
    this.svg.append('g').classed('axis', true).classed(`${this.cssPrefix}-xline`, true);
    const chartGroup = this.svg.append('g').classed(`${this.cssPrefix}-chart`, true);
    chartGroup.append('rect').classed(`${this.cssPrefix}-touch-area`, true);
    chartGroup.append('g').classed(`${this.cssPrefix}-bars`, true);
    chartGroup.append('g').classed(`${this.cssPrefix}-hover`, true);
    error_1.initError.call(this);
  }
  async data(promises, options) {
    const fetched = await error_1.tryChartPromises.call(this, promises);
    if (!fetched) return null;
    const {
      data,
      parent
    } = fetched;
    const startDate = options.startDate || options.startYear;
    const endDate = options.endDate || options.endYear;
    const filtered = {
      ...data[0],
      metric: {
        ...data[0].metric,
        data: data[0].metric.data.filter(_ref => {
          let {
            key,
            value
          } = _ref;
          if (value === null || value === undefined) {
            return false;
          }
          if (startDate && key < (0, chart_helpers_1.dateParser)(startDate, data[0].metric.xType)) {
            return false;
          }
          if (endDate && key > (0, chart_helpers_1.dateParser)(endDate, data[0].metric.xType)) {
            return false;
          }
          return true;
        })
      }
    };
    return {
      data: filtered,
      parent
    };
  }
  getDrawParams(_ref2) {
    let {
      data,
      parent,
      options: {
        hideAxisLabels = false,
        hideGridlines = false,
        showZeroLine = false,
        primaryColor = colours_module_scss_1.default.chartcolourdefault0,
        axisTextColor = null,
        gridColor = null,
        positiveColour = null,
        negativeColour = null,
        selectedDates = [],
        transition = false,
        transitionDuration = TRANSITION_LENGTH,
        yDomain = null,
        xValues = null,
        yValues = null,
        heightToWidthRatio = null,
        xTickFormat = null,
        hideTitle = false,
        showSourcesAndFootnotes = true,
        ...otherOptions
      }
    } = _ref2;
    return {
      ...(0, chart_helpers_1.getDefaultDrawParams)({
        data: [data],
        parent,
        options: otherOptions
      }, this.margins),
      hideAxisLabels,
      hideGridlines,
      showZeroLine,
      primaryColor,
      axisTextColor,
      gridColor,
      positiveColour,
      negativeColour,
      selectedDates,
      transition,
      transitionDuration,
      yDomain,
      xValues,
      yValues,
      heightToWidthRatio,
      xTickFormat,
      hideTitle,
      showSourcesAndFootnotes
    };
  }
  createYScale(_ref3) {
    let {
      data,
      params
    } = _ref3;
    const {
      yDomain,
      margins
    } = params;
    const values = data.metric.data.map(_ref4 => {
      let {
        value
      } = _ref4;
      return Number(value);
    });
    const dataYDomain = [Math.min(0, lodash_1.default.min(values)), Math.max(0, lodash_1.default.max(values))];
    return d3.scaleLinear().domain(yDomain || dataYDomain).range([this.height - margins.bottom, margins.top]).nice(this.yTicks);
  }
  yAxisOffset(drawParams, yScale, fontSize) {
    const {
      params: {
        margins,
        hideAxisLabels
      }
    } = drawParams;
    const measuredAxisWidth = measureYAxis(drawParams, yScale.ticks(this.yTicks), fontSize);
    const yAxisWidth = margins.fixedAxis === undefined ? measuredAxisWidth : parseFloat(margins.fixedAxis);
    return hideAxisLabels === true || hideAxisLabels === 'y' ? 0 : yAxisWidth;
  }
  createXScale(drawParams, yScale) {
    let axisPadding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : AXIS_PADDING;
    const {
      data,
      params
    } = drawParams;
    const {
      margins,
      fontSize
    } = params;
    const rightRange = this.width - margins.right - LABEL_PADDING;
    const dates = lodash_1.default.map(data.metric.data, 'key');
    const dateRangeFunction = data.metric.xType ? dateRangeFunctions[data.metric.xType.toLowerCase()] : d3.utcYear;
    const lastDate = dateRangeFunction.floor(lodash_1.default.max(dates));
    const dataXDomain = dateRangeFunction.range(dateRangeFunction.floor(lodash_1.default.min(dates)), lastDate);
    dataXDomain.push(lastDate);
    return d3.scaleBand().paddingOuter(0.1).paddingInner(0.2).domain(dataXDomain).range([margins.left + this.yAxisOffset(drawParams, yScale, fontSize) + axisPadding, rightRange]);
  }
  createScales(drawParams) {
    const yScale = this.createYScale(drawParams);
    const xScale = this.createXScale(drawParams, yScale);
    return {
      xScale,
      yScale
    };
  }
  resizeContent(newRect) {
    const {
      width,
      height
    } = newRect;
    if (this.cachedParams && (this.width !== width || this.height !== height)) {
      this.drawContent(this.cachedParams, false);
    }
  }
  xAccessor(d) {
    let usePadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (usePadding) return this.xScale(d.key);
    return this.xScale(d.key) - (this.xScale.step() - this.xScale.bandwidth()) / 2;
  }
  heightAccessor(d) {
    return Math.abs(this.yScale(d.value) - this.yScale(0));
  }
  yAccessor(d) {
    return d.value >= 0 ? this.yScale(d.value) : this.yScale(0);
  }
  widthAccessor() {
    let usePadding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (usePadding) return this.xScale.bandwidth();
    return this.xScale.step();
  }
  posNegColours(params, d) {
    if (this.yAccessor(d) === this.yScale(0)) {
      return params.negativeColour;
    }
    return params.positiveColour;
  }
  entryColour(d, params, xType) {
    const defaultReturn = d.primaryColor || (this.hasPosNegColours ? this.posNegColours(params, d) : (0, chart_helpers_1.getColour)(d, 0, params));
    if (params.selectedDates.length > 0) {
      const dates = params.selectedDates.map(date => (0, chart_helpers_1.dateParser)(date, xType).getTime());
      if (lodash_1.default.includes(dates, d.key.getTime())) {
        return defaultReturn;
      }
      return colours_module_scss_1.default.chartcolourgrey;
    }
    return defaultReturn;
  }
  static entryOpacity(d, _ref5, hovered) {
    let {
      data,
      params
    } = _ref5;
    if (!params.selectedDates || params.selectedDates.length === 0) {
      return 1;
    }
    const {
      xType
    } = data.metric;
    const dates = params.selectedDates.map(date => (0, chart_helpers_1.dateParser)(date, xType).getTime());
    if (lodash_1.default.includes(dates, d.key.getTime()) || hovered && d.key.getTime() === hovered.getTime()) {
      return 1;
    }
    return 0.4;
  }
  setHovered(hovered) {
    if (this.cachedParams) {
      const entries = this.svg.select(`g.${this.cssPrefix}-bars`).selectAll(`g.${this.cssPrefix}-entry`);
      entries.style('opacity', d => TimeBarChart.entryOpacity(d, this.cachedParams, hovered)).selectAll('rect').classed('bar-hovered', d => hovered && d.key.getTime() === hovered.getTime());
    }
  }
  areaHeight() {
    return Math.max(0, this.yScale.range()[0] + AXIS_PADDING);
  }
  async draw(promises) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const allData = await this.data(promises, options);
    if (!allData) {
      this.trigger('dataLoaded', false);
      return false;
    }
    const {
      data,
      parent
    } = allData;
    const optionParams = this.getDrawParams({
      data,
      parent,
      options
    });
    this.hasPosNegColours = optionParams.positiveColour !== null && optionParams.negativeColour !== null;
    const drawParams = {
      data,
      parent,
      params: optionParams
    };
    this.drawContent(drawParams);
    this.trigger('finishDraw');
    this.trigger('dataLoaded', true);
    return true;
  }
  drawContent(drawParams) {
    let overrideTransition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    this.cachedParams = drawParams;
    this.width = this.container.node().getBoundingClientRect().width;
    const {
      data,
      params
    } = drawParams;
    const shouldTransition = overrideTransition ?? params.transition;
    if (params.titleVerticalPosition === 'top') {
      this.title.classed('below', false);
      this.container.node().insertBefore(this.title.node(), this.svg.node());
      this.container.node().insertBefore(this.subtitle.node(), this.svg.node());
    } else if (params.titleVerticalPosition === 'bottom') {
      this.title.classed('below', true);
      this.container.node().append(this.title.node());
      this.container.node().append(this.subtitle.node());
    }
    if (!params.hideTitle) {
      chart_helpers_1.drawTitle.call(this, this.title, this.subtitle, drawParams);
    }
    if (params.showSourcesAndFootnotes) {
      this.sources.draw([data]);
      this.container.node().append(this.sourceContainer.node());
    } else {
      this.sourceContainer.style('display', 'none');
    }
    if (params.heightToWidthRatio) {
      this.height = params.heightToWidthRatio * this.width;
    } else {
      const {
        height: titleHeight
      } = this.title.node().getBoundingClientRect();
      const {
        height: subtitleHeight
      } = this.subtitle.node().getBoundingClientRect();
      const {
        height: wrapperHeight
      } = this.container.node().getBoundingClientRect();
      const {
        height: sourcesHeight
      } = this.sourceContainer.node().getBoundingClientRect();
      this.height = wrapperHeight - titleHeight - subtitleHeight - sourcesHeight;
    }
    d3.select(this.svg.node()).attr('viewBox', `0 0 ${this.width} ${this.height}`);
    const oldDates = this.xScale ? this.xScale.domain() : null;
    const {
      xScale,
      yScale
    } = this.createScales({
      data,
      params
    });
    this.xScale = xScale;
    this.yScale = yScale;
    const newDates = this.xScale.domain();
    const doDoubleTransition = JSON.stringify(oldDates) !== JSON.stringify(newDates);
    const maskID = this.newDefsID();
    this.drawEntries(drawParams, doDoubleTransition, shouldTransition);
    this.drawAxisMask(maskID);
    this.drawAxes(drawParams, xScale, yScale, maskID, doDoubleTransition, shouldTransition);
    this.svg.select(`.${this.cssPrefix}-touch-area`).attr('x', 0).attr('y', 0).attr('width', this.width).attr('height', this.areaHeight()).on('click', () => {
      if ('ontouchstart' in window) {
        this.tooltip.hide();
      }
    }, {
      passive: true
    });
    if (params.info && params.info.position === 'chart') {
      InfoTooltip_1.default.inChart(this.container, params);
    }
    this.initialDraw = false;
  }
  createXAxis(_ref6, xScale, yScale) {
    let {
      data,
      params
    } = _ref6;
    const {
      xValues,
      xTickFormat,
      transition
    } = params;
    const keys = lodash_1.default.uniqBy(data.metric.data, _ref7 => {
      let {
        key
      } = _ref7;
      return key.getTime();
    }).map(_ref8 => {
      let {
        key
      } = _ref8;
      return key;
    });
    let allDates = keys;
    if (['yearly', 'years'].includes(data.metric.xType)) {
      allDates = d3.utcYear.range(d3.min(keys), d3.max(keys));
      allDates.push(d3.max(keys));
    } else if (['monthly', 'months'].includes(data.metric.xType)) {
      allDates = d3.utcMonth.range(d3.min(keys), d3.max(keys));
      allDates.push(d3.max(keys));
    } else if (['weekly', 'weeks'].includes(data.metric.xType)) {
      allDates = d3.utcWeek.range(d3.min(keys), d3.max(keys));
      allDates.push(d3.max(keys));
    } else if (['daily', 'days'].includes(data.metric.xType)) {
      allDates = d3.utcDay.range(d3.min(keys), d3.max(keys));
      allDates.push(d3.max(keys));
    }
    const [yEnd] = yScale.range();
    const axis = d3.axisBottom(xScale).tickSize(0);
    if (xValues) {
      axis.tickValues(xValues.filter(v => xScale(v) !== undefined));
    } else {
      axis.tickValues((0, chart_helpers_1.barXAxisDates)(allDates, data.metric.xType, this.xTicks));
    }
    if (xTickFormat) {
      axis.tickFormat(xTickFormat);
    } else {
      // default D3 time axis format
      axis.tickFormat(d3.scaleUtc().tickFormat());
    }
    const translate = yEnd + AXIS_PADDING;
    const returnAxis = this.svg.select('.axis.x');
    if (!this.initialDraw && transition) {
      returnAxis.transition((0, transitions_1.immediateTransition)(params)).attr('transform', `translate(0, ${translate})`).call(axis);
    } else {
      returnAxis.attr('transform', `translate(0, ${translate})`).call(axis);
    }
    return returnAxis;
  }
  createYAxis(drawParams, xScale, yScale, doDoubleTransition) {
    let transition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    const {
      params,
      params: {
        yValues
      }
    } = drawParams;
    const [xStart, xEnd] = xScale.range();
    const axis = d3.axisLeft(yScale).tickSize(xStart - xEnd).tickPadding(AXIS_PADDING);
    if (yValues) {
      axis.tickValues(yValues);
    } else {
      axis.ticks(this.yTicks).tickFormat(t => (0, chart_helpers_1.valueFormat)(drawParams)(t, {
        ticks: yScale.ticks(this.yTicks)
      }));
    }
    const returnAxis = this.svg.select('.axis.y');
    const transitionTiming = doDoubleTransition ? transitions_1.delayedTransition : transitions_1.immediateTransition;
    if (!this.initialDraw && transition) {
      returnAxis.transition(transitionTiming(params)).call(axis);
    } else {
      returnAxis.call(axis);
    }
    return returnAxis;
  }
  newDefsID() {
    let idCount = 0;
    let id = `${this.cssPrefix}-mask-${idCount}`;
    let maskExistsSelection = d3.select(`#${id}`);
    while (!maskExistsSelection.empty() && idCount < 1000) {
      idCount += 1;
      id = `${this.cssPrefix}-mask-${idCount}`;
      maskExistsSelection = d3.select(`#${id}`);
    }
    return id;
  }
  drawAxisMask(maskID) {
    let mask = this.defs.select('mask');
    if (mask.empty()) {
      mask = this.defs.append('mask');
      mask.append('rect');
    }
    mask.attr('id', maskID).select('rect').attr('x', -100).attr('y', 0).attr('width', this.width + 100).attr('height', this.areaHeight()).attr('fill', 'white');
  }
  drawAxes(drawParams, xScale, yScale, maskID, doDoubleTransition) {
    let transition = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    const {
      params: {
        hideGridlines,
        showZeroLine,
        hideAxisLabels,
        axisTextColor,
        gridColor,
        fontSize
      }
    } = drawParams;
    const [xStart, xEnd] = xScale.range();
    const width = xEnd - xStart;
    if (width > 760) {
      this.xTicks = 8;
    } else if (width > 400) {
      this.xTicks = 4;
    } else if (width > 180) {
      this.xTicks = 3;
    } else {
      this.xTicks = 2;
    }
    if (this.height > 300) {
      this.yTicks = 4;
    } else {
      this.yTicks = 3;
    }
    const xAxis = this.createXAxis(drawParams, xScale, yScale);
    xAxis.selectAll('.tick text').style('display', hideAxisLabels === true || hideAxisLabels === 'x' ? 'none' : null).style('fill', axisTextColor).style('font-size', `${fontSize}px`);
    const yAxis = this.createYAxis(drawParams, xScale, yScale, doDoubleTransition, transition);
    yAxis.attr('mask', `url(#${maskID})`).selectAll('.tick line').classed('bold', d => !yScale.domain().includes(0) && d === 0).classed('zero-line', d => d === 0).style('display', d => {
      if (showZeroLine && d === 0) {
        return null;
      }
      if (hideGridlines) {
        return 'none';
      }
      return null;
    }).style('stroke', gridColor);
    yAxis.selectAll('.tick text').style('fill', axisTextColor).style('display', hideAxisLabels === true || hideAxisLabels === 'y' ? 'none' : null).style('font-size', `${fontSize}px`);
    this.svg.select('.axis.y').attr('transform', `translate(${xStart}, 0)`);
    return {
      xAxis,
      yAxis
    };
  }
  drawEntries(drawParams, doDoubleTransition) {
    let transition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const {
      data,
      params
    } = drawParams;
    const chartGroup = this.svg.select(`g.${this.cssPrefix}-chart`);
    const chartBarsGroup = chartGroup.select(`g.${this.cssPrefix}-bars`);
    const chartHoverGroup = chartGroup.select(`g.${this.cssPrefix}-hover`);
    const callbacks = bars => {
      bars.on('mousemove', lodash_1.default.throttle((event, d) => {
        this.showTooltip(drawParams, d, this.tooltipColour(d, params));
        this.setHovered(d.key);
        this.trigger('hover', d);
        this.trigger('point', d);
      }, constants_1.THROTTLE, {
        trailing: false
      }), {
        passive: true
      }).on('mouseout', () => {
        this.tooltip.hide();
        this.setHovered();
        this.trigger('mouseout');
        this.trigger('point', null);
      }, {
        passive: true
      }).on('click', (event, d) => {
        this.trigger('click', d);
      }, {
        passive: true
      });
    };
    // create bar selections
    const entriesUpdate = chartBarsGroup.selectAll(`g.${this.cssPrefix}-entry`).data(data.metric.data, d => d.key.getTime());
    const entriesEnter = entriesUpdate.enter().append('g').classed(`${this.cssPrefix}-entry`, true).style('opacity', d => TimeBarChart.entryOpacity(d, drawParams));
    const entriesExit = entriesUpdate.exit();
    const barSelections = {
      enter: entriesEnter,
      update: entriesUpdate,
      exit: entriesExit
    };
    // draw bars with updated data
    this.drawEntryRects(drawParams, barSelections, doDoubleTransition, transition);
    // create hover selections
    const hoverUpdate = chartHoverGroup.selectAll(`g.${this.cssPrefix}-hover-bar`).data(data.metric.data, d => d.key.getTime()).call(callbacks);
    const hoverEnter = hoverUpdate.enter().append('g').classed(`${this.cssPrefix}-hover-bar`, true).call(callbacks);
    const hoverExit = hoverUpdate.exit();
    const hoverSelections = {
      enter: hoverEnter,
      update: hoverUpdate,
      exit: hoverExit
    };
    // draw hover bars with updated data
    this.drawEntryRects(drawParams, hoverSelections, doDoubleTransition, transition, () => 0, () => this.areaHeight(), false);
    if (transition && !this.initialDraw) {
      entriesUpdate.transition((0, transitions_1.immediateTransition)(params)).style('opacity', d => TimeBarChart.entryOpacity(d, drawParams));
      entriesExit.transition((0, transitions_1.immediateTransition)(params)).remove();
    } else {
      entriesUpdate.style('opacity', d => TimeBarChart.entryOpacity(d, drawParams));
      entriesExit.remove();
    }
    hoverExit.remove();
    chartBarsGroup.selectAll(`g.${this.cssPrefix}-entry`).style('cursor', this.hasAction('click') ? 'pointer' : null);
  }
  drawEntryRects(_ref9, _ref10, doDoubleTransition) {
    let {
      data,
      params
    } = _ref9;
    let {
      enter,
      update,
      exit
    } = _ref10;
    let transition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    let yAccessor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.yAccessor;
    let heightAccessor = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : this.heightAccessor;
    let usePadding = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
    enter.append('rect').classed('entry-rect', true);
    const rectUpdate = update.select('.entry-rect');
    const rectEnter = enter.select('.entry-rect');
    const rectExit = exit.select('.entry-rect');
    const setRectEnterAttrs = selection => {
      selection.attr('width', this.widthAccessor(usePadding)).attr('height', d => heightAccessor.call(this, d)).attr('fill', d => this.entryColour(d, params, data.metric.xType)).attr('x', d => this.xAccessor(d, usePadding)).attr('y', d => yAccessor.call(this, d)).style('opacity', 0);
    };
    const rectUpdateFirstTransition = selection => {
      selection.attr('x', d => this.xAccessor(d, usePadding)).attr('width', this.widthAccessor(usePadding)).style('opacity', 1);
    };
    const rectUpdateSecondTransition = selection => {
      selection.attr('y', d => yAccessor.call(this, d)).attr('height', d => heightAccessor.call(this, d));
    };
    const combinedUpdate = selection => {
      selection.call(rectUpdateFirstTransition).call(rectUpdateSecondTransition);
    };
    const enterTransitionTiming = doDoubleTransition ? transitions_1.delayedTransition : transitions_1.immediateTransition;
    if (transition && !this.initialDraw) {
      rectEnter.call(setRectEnterAttrs).transition(enterTransitionTiming(params)).call(transitions_1.fadeIn);
      rectUpdate.attr('fill', d => this.entryColour(d, params, data.metric.xType));
      if (doDoubleTransition) {
        rectUpdate.transition((0, transitions_1.immediateTransition)(params)).call(rectUpdateFirstTransition).transition((0, transitions_1.immediateTransition)(params)).call(rectUpdateSecondTransition);
      } else {
        rectUpdate.transition((0, transitions_1.immediateTransition)(params)).call(combinedUpdate);
      }
      rectExit.transition((0, transitions_1.immediateTransition)(params)).call(transitions_1.fadeOut);
    } else {
      rectEnter.call(setRectEnterAttrs).call(transitions_1.fadeIn);
      rectUpdate.attr('fill', d => this.entryColour(d, params, data.metric.xType)).call(combinedUpdate);
    }
    // crispEdges looks bad when the space between bars is less than 1 pixel
    rectEnter.merge(rectUpdate).style('shape-rendering', this.xScale.step() - this.xScale.bandwidth() >= 1 ? 'crispEdges' : null);
  }
  tooltipColour(d, params) {
    return this.hasPosNegColours ? this.posNegColours(params, d) : (0, chart_helpers_1.primaryColour)(params, d);
  }
  showTooltip(drawParams, d, colour) {
    const {
      data
    } = drawParams;
    const containerDim = this.container.node().getBoundingClientRect();
    const svgDim = this.svg.node().getBoundingClientRect();
    const barD = d.value;
    if (barD === null || barD === undefined) {
      return;
    }
    const x = this.xAccessor(d) + this.xScale.bandwidth() / 2;
    const y = svgDim.top - containerDim.top + this.yAccessor(d);
    const dataLabel = (data.metric.lexiconName || data.metric.name) + (data.metric.geo_id && data.metric.geo_id !== 'US' ? ` in ${data.metric.geo_name}` : '');
    const format = (0, chart_helpers_1.tooltipFormat)({
      ...drawParams,
      data: [data]
    });
    const topContent = {
      title: {
        value: data.tooltipTitle ?? dataLabel
      },
      subtitle: {
        value: (0, chart_helpers_1.dateFormat)(d.key, data.metric.xType)
      }
    };
    this.tooltip.draw(x, y, topContent, [{
      type: 'value',
      value: format(barD)
    }], {
      primaryColour: colour
    });
  }
}
exports.default = TimeBarChart;